/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const AsyncDiscoverSection: LazyComponent<() => React.JSX.Element | null> = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-app-menu-recommended-apps" */ './discover-section/DiscoverSection.tsx'
		).then((module) => module.DiscoverSection),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncDiscoverSectionPostOffice: LazyComponent<() => React.ReactElement | null> =
	lazyForPaint(
		() =>
			import(
				/* webpackChunkName: "async-app-menu-recommended-apps-post-office" */ './discover-section-post-office/DiscoverSectionPostOffice.tsx'
			).then((module) => module.DiscoverSectionPostOffice),
		{
			includeInShellOnlySsrBundle: false,
			entryFsSsrLiftImportToModule: true,
		},
	);
